module.exports = __webpack_public_path__ + "img/check_03.d7525eb1.png";